import React from 'react';
import { string } from 'prop-types';
import { Router, BrowserRouter } from 'react-router-dom';
import { createMemoryHistory, createLocation } from 'history';
import useHydrate from '../../../hooks/useHydrate';

const ClientSideRouting = ({ path, children }) => {
  const hydrated = useHydrate();

  if (!hydrated) {
    const memoryHistory = createMemoryHistory({ initialEntries: [createLocation(path)] });
    return <Router history={memoryHistory}>{children}</Router>;
  }

  return <BrowserRouter>{children}</BrowserRouter>;
};

ClientSideRouting.propTypes = {
  path: string.isRequired
};

export default ClientSideRouting;
